import React from "react";
import styled, { keyframes } from "styled-components";

/*
  On duplique trois fois et l’animation décale d’exactement 1/3 de la largeur
  totale (-33.333 %) : lorsque la première série sort à gauche, la deuxième
  prend le relais, sans remise à zéro visible.
*/
const scroll = keyframes`
  0%   { transform: translateX(0); }
  100% { transform: translateX(-33.333333%); }
`;

const Wrapper = styled.div`
  overflow: hidden;
  position: relative;
  padding: 1rem 0;
  background: var(--my-color1);
  mask-image: linear-gradient(
    to right,
    transparent,
    #000 10%,
    #000 90%,
    transparent
  );
`;

const Track = styled.div`
  display: flex;
  gap: 1.2rem;
  width: max-content; /* largeur auto selon contenu */
  animation: ${scroll} ${({ speed }) => speed}s linear infinite;
  will-change: transform;
`;

const Badge = styled.div`
  flex: 0 0 auto;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  svg {
    font-size: 26px;
    color: var(--my-color5);
  }
  span {
    font-size: 0.75rem;
    color: var(--my-color3);
  }
`;

const ScrollingBadges = ({ items, speed = 18, style }) => {
  // On duplique trois fois pour une animation –33.333 % sans coupure
  const doubled = [...items, ...items, ...items];
  return (
    <Wrapper style={style}>
      <Track speed={speed}>
        {doubled.map((it, i) => (
          <Badge key={i}>
            {it.icon}
            <span>{it.label}</span>
          </Badge>
        ))}
      </Track>
    </Wrapper>
  );
};

export default ScrollingBadges;
